/** Read-only Oasis field with a full-value hover tooltip. */

import { Tooltip } from "@risalabs_frontend_org/oasis-ui-kit";
import { TextInput } from "risa-oasis-ui_v2";

/** Props for one structured evidence field. */
export interface StructuredEvidenceFieldProps {
  id: string;
  label: string;
  value: string;
}

/** Render a compact field while exposing long content on hover or focus. */
export function StructuredEvidenceField({
  id,
  label,
  value,
}: StructuredEvidenceFieldProps) {
  return (
    <Tooltip
      content={
        <div className="max-h-80 overflow-y-auto whitespace-pre-wrap break-words text-xs leading-5">
          {value}
        </div>
      }
      placement="top"
      delay={150}
      disabled={!value}
      maxWidth={520}
      maxHeight={360}
    >
      <div className="min-w-0">
        <TextInput
          id={id}
          label={label}
          readOnly
          defaultValue={value}
        />
      </div>
    </Tooltip>
  );
}
